
const digest = 'ab4d1d89c03b3be812c0739036b8cea689f3dcbb3aadae5f95979b24413f9494';
const classes = {"wrapper":"_wrapper_vj5p6_1","borderActive":"_borderActive_vj5p6_8","video":"_video_vj5p6_12","title":"_title_vj5p6_18","checkbox":"_checkbox_vj5p6_24","active":"_active_vj5p6_33"};
const css = `._wrapper_vj5p6_1 {
  font-family: Rubik, sans-serif;
  border: 2px solid #e2e5ed;
  padding: 10px;
  border-radius: 15px;
}

._borderActive_vj5p6_8 {
  border-color: #1d65d8;
}

._video_vj5p6_12 {
  width: 100%;
  height: 200px;
  background-color: coral;
}

._title_vj5p6_18 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}

._checkbox_vj5p6_24 {
  width: 25px;
  height: 25px;
  background: url("/dist/icons/react/fakebox.svg") no-repeat center;
  background-size: contain;
  margin-bottom: 10px;
  cursor: pointer;
}

._active_vj5p6_33 {
  background: url("/dist/icons/react/fakebox-checked.svg") no-repeat center;
  background-size: contain;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  